import { styled } from "@mui/material";
import { IStyledMainContentProps } from "./types";
import { drawerWidth } from "../../../consts/drawerWidth";

const APPBAR_HEIGHT = 64; // px, should match AppBar minHeight

const StyledMainContent = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<IStyledMainContentProps>(({ theme, open }) => ({
  // ensure main sits below the AppBar and never exceeds the viewport
  flexGrow: 1,
  marginTop: `${APPBAR_HEIGHT}px`,
  height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
  overflow: 'auto',
  padding: theme.spacing(2),
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  maxWidth: '100%',
  marginRight: open ? drawerWidth : 0,
  position: 'relative',
  boxSizing: 'border-box',
}));

export { StyledMainContent }